import { render, staticRenderFns } from "./FormulaForm.vue?vue&type=template&id=2315df5a&scoped=true&"
import script from "./FormulaForm.vue?vue&type=script&lang=js&"
export * from "./FormulaForm.vue?vue&type=script&lang=js&"
import style0 from "./FormulaForm.vue?vue&type=style&index=0&id=2315df5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315df5a",
  null
  
)

export default component.exports